import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MessageSquare } from "lucide-react";

export default function AdminContactMessages() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/contact-messages").then((r) => setItems(r.data)); }, []);

  return (
    <div data-testid="admin-contact-page">
      <div className="mb-6">
        <div className="eyebrow mb-2">Inbox</div>
        <h1 className="font-display text-3xl font-semibold text-slate-900 tracking-tight">Contact messages</h1>
      </div>
      {items.length === 0 ? (
        <div className="border border-dashed border-slate-200 rounded-md p-12 text-center text-slate-500"><MessageSquare className="w-8 h-8 mx-auto mb-2 text-slate-300" strokeWidth={1.5}/>No messages.</div>
      ) : (
        <div className="space-y-3">
          {items.map((m) => (
            <div key={m.id} className="border border-slate-200 rounded-md bg-white p-5">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="text-sm font-medium text-slate-900">{m.name} <span className="text-slate-500">·</span> <a href={`mailto:${m.email}`} className="text-slate-600 hover:text-blue-700">{m.email}</a></div>
                  <div className="mt-1 text-sm text-slate-800">{m.subject}</div>
                </div>
                <div className="text-xs text-slate-500">{new Date(m.created_at).toLocaleString()}</div>
              </div>
              <div className="mt-3 text-sm text-slate-700 whitespace-pre-wrap">{m.message}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
